import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/profile/useProfileQueryKeys.ts
var t = e("profile", { hostProfile: () => ["hostProfile"] });
//#endregion
export { t as profileQueryKeys };
